/**
 * 表单验证工具模块
 * 提供用户名、密码、邮箱等表单字段的验证功能
 */

/** 用户名验证正则：3-20位字母、数字、下划线 */
export const USERNAME_PATTERN = /^[a-zA-Z0-9_]{3,20}$/;

/** 密码验证正则：6-20位，必须包含字母和数字或特殊字符 */
export const PASSWORD_PATTERN =
  /^(?![A-Za-z]+$)(?!\d+$)(?![^A-Za-z\d]+$)\S{6,20}$/;

/** 邮箱验证正则：标准邮箱格式 */
export const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

/**
 * 标准化输入值
 * @param {*} value - 输入值
 * @returns {string} 返回字符串，null/undefined 转为空字符串
 */
export const normalizeInputValue = (value) => `${value ?? ""}`;

/**
 * 去除输入值首尾空格
 * @param {*} value - 输入值
 * @returns {string} 返回去除首尾空格的字符串
 */
export const trimInputValue = (value) => normalizeInputValue(value).trim();

/**
 * 验证用户名格式
 * @param {*} value - 待验证的用户名
 * @returns {boolean} 用户名是否有效（3-20位字母、数字、下划线）
 */
export const isValidSpecUsername = (value) => {
  return USERNAME_PATTERN.test(trimInputValue(value));
};

/**
 * 验证用户名或邮箱格式
 * @param {*} value - 待验证的用户名或邮箱
 * @returns {boolean} 用户名或邮箱是否至少有一个有效
 */
export const isValidSpecUsernameOrEmail = (value) => {
  const normalizedValue = trimInputValue(value);

  if (!normalizedValue) {
    return false;
  }

  return (
    isValidSpecUsername(normalizedValue) || isValidSpecEmail(normalizedValue)
  );
};

/**
 * 验证密码格式
 * @param {*} value - 待验证的密码
 * @returns {boolean} 密码是否有效（6-20位，必须包含字母和数字或特殊字符）
 */
export const isValidSpecPassword = (value) => {
  return PASSWORD_PATTERN.test(normalizeInputValue(value));
};

/**
 * 验证邮箱格式
 * @param {*} value - 待验证的邮箱
 * @returns {boolean} 邮箱是否有效（5-254位，符合标准邮箱格式）
 */
export const isValidSpecEmail = (value) => {
  const email = trimInputValue(value);

  if (email.length < 5 || email.length > 254) {
    return false;
  }

  return EMAIL_PATTERN.test(email);
};
